import { TFunction } from 'i18next';
import { z } from 'zod';

export const timeEntryFormSchema = (t: TFunction) =>
  z.object({
    projectId: z.string({
      required_error: t('common:error.required'),
    }),
    date: z.date({
      required_error: t('common:error.required'),
      invalid_type_error: t('common:error.invalid'),
    }),
    startTime: z.string().regex(/^([01]?\d|2[0-3]):([0-5]\d)$/, t('common:error.invalid')),
    duration: z
      .object({
        hours: z
          .number()
          .int()
          .min(0, t('common:error.minValue', { value: 0 }))
          .max(23, t('common:error.maxValue', { value: 23 })),
        minutes: z
          .number()
          .int()
          .min(0)
          .max(59, t('common:error.maxValue', { value: 59 })),
      })
      .refine(d => d.hours > 0 || d.minutes > 0, {
        message: t('common:error.required'),
      }),
    description: z.string().optional(),
  });

export type TimeEntryFormValues = z.infer<ReturnType<typeof timeEntryFormSchema>>;
